import { render, staticRenderFns } from "./KeyGroup.vue?vue&type=template&id=f6c7f5ae&scoped=true&lang=pug"
import script from "./KeyGroup.vue?vue&type=script&lang=js"
export * from "./KeyGroup.vue?vue&type=script&lang=js"
import style0 from "./KeyGroup.vue?vue&type=style&index=0&id=f6c7f5ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c7f5ae",
  null
  
)

export default component.exports